import { render, staticRenderFns } from "./PopupsHome.vue?vue&type=template&id=f71b1180&"
import script from "./PopupsHome.vue?vue&type=script&lang=js&"
export * from "./PopupsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports